
/* eslint-disable */
import {
  defineComponent,
  PropType,
  onMounted,
  reactive,
  toRef,
  toRefs,
  ref,
  computed,
  watch,
  onActivated
} from "vue";
import $api from "@/api/main";
import { ElMessage } from "element-plus";
import utils from "@/utils/utils";
export default defineComponent({
  props: {
    /**
     *  传入的当前流程信息
     */
    modelValue: {
      type: Object as PropType<any>,
      default: (): any => {
        return [];
      },
    },
    /**
     *  当前流程的信息
     */
    workflowType: {
      type: String,
      default: "",
    },
    /**
     *  当前流程是否显示状态
     */
    showStatus: {
      type: Boolean,
      default: false,
    },
    /**
     *  当前流程审核节点ID
     */
    currentTask:{
      type: String,
      default: "",
    },
    /**
     *  是否展示显示状态下的用户名称
     */
    showReviewerName:{
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const workType = props.workflowType;
    const selectAuditUser = ref();
    let selectNode: any = ref({});
    const visible = ref(false);
    const departmentDir: any = {
      材设部: "material",
      项目部: "engineering",
      经营部: "business",
      质安部: "engineering",
      综合部: "comprehensive",
      财务部: "finance",
      项目经理: "engineering",
      材料员: "material",
      预算员: "business",
      预算部经理: "business",
      财务员: "finance",
      财务员1: "finance",
      财务员2: "finance",
      行政员: "comprehensive",
      副总经理: "manager",
      总经理: "comprehensive",
      分管领导: "manager",
      质安员: "quality",
      质安负责人: "quality",
      质安部负责人: "quality",
      综合部领导: "comprehensive",
      部门领导: utils.$cookie.getCookie("hxStaffDept"),
      行政代总经理: "comprehensive",
    };

    const departmentCodeDir: any = {
      engineering: "工程部",
      finance: "财务部",
      material: "材设部",
      business: "经营部",
      quality: "质安部",
      comprehensive: "综合部",
      manager: "总经办",
    };

    const data: any = reactive({
      tree: [],
      flowList: props.modelValue,
      expand: [],
      pathTable: {},
      componentKey: new Date().getTime(),
      currentApproval: 0,
    });

    if(props.showStatus && (props.currentTask === '' || props.currentTask === 'null')){
      data.currentApproval = 99;
    }
    /**
     * 获取员工树
     */
    const createPathTable = (tree: any[], pathArray: any[], indexs: any[]) => {
      for (let index = 0; index < tree.length; index++) {
        pathArray.push(tree[index].code);
        indexs.push(index);
        data.pathTable[tree[index].code] = {
          path: [...pathArray],
          name: tree[index].name,
          indexs: [...indexs],
          selectable: tree[index].selectable,
          deptName: departmentCodeDir[tree[index].parentCode],
        };
        if (tree[index].children) {
          createPathTable(tree[index].children, pathArray, indexs);
        }
        pathArray.pop();
        indexs.pop();
      }
    };
    /**
     * 获取员工树
     */
    const getStaffTree = async () => {
      data.tree = await $api.getStaffTree({
        deptCode: departmentDir[selectNode ? selectNode.taskName : ""]
          ? departmentDir[selectNode.taskName]
          : "",
      });
      createPathTable(data.tree, [], []);
    };

    /**
     * 获取流程节点信息并回显审核人
     */
    const getProcessNodeInfoFn = async () => {
      if (props.workflowType === "common_flow" || props.workflowType === "office_supplies_use" || props.workflowType === "seal_apply" || props.workflowType === 'common_contract') return;
      if(props.workflowType){
        let result = await $api.getProcessNodeInfo(props.workflowType);
        data.currentApproval = 99;
        result.forEach((item: any, index: any) => {
          if(item.id === props.currentTask){
            data.currentApproval = index;
          }
        });
        if (data.flowList.length == 0) {
          result.forEach((item: any, index: any) => {
            data.flowList.push({
              assignee: "",
              assigneeName: "",
              taskDefinitionKey: item.id,
              taskName: item.name,
            });
          });
          ctx.emit("update:modelValue", data.flowList);
        }
      }
    };

    /**
     * 新增审核人
     */
    const appendFn = (node: any) => {
      if(props.showStatus) return;
      selectAuditUser.value = "";
      visible.value = !visible.value;
      selectNode = node;
      getStaffTree();
    };

    /**
     * 监听审核人的code变化
     */
    watch(
      () => selectAuditUser.value,
      () => {
        if (selectAuditUser.value) {
          if (selectNode !== "") {
            selectNode.assignee = selectAuditUser.value;
            selectNode.assigneeName =
              data.pathTable[selectAuditUser.value].name;
          } else {
            data.flowList.push({
              assignee: selectAuditUser.value,
              assigneeName: data.pathTable[selectAuditUser.value].name,
              taskName: data.pathTable[selectAuditUser.value].deptName,
            });
          }
          ctx.emit("update:modelValue", data.flowList);
        }
      }
    );
    /**
     * 监听modelValue变化
     */
    watch(
      () => props.modelValue,
      (val) => {
        if(val.length > 0){
          data.currentApproval = 99;
          val.forEach((item: any, index: any)=>{
            if(item.taskDefinitionKey === props.currentTask){
              data.currentApproval = index;
            }
          });
          if(data.flowList.length > 0 && (data.flowList.length === val.length)){
            data.flowList.forEach((item: any, index: any)=>{
              item.assignee = val[index].assignee;
              item.assigneeName = val[index].assigneeName;
            });
          }else{
            data.flowList = val;
          }
        }else{
          data.flowList = [];
          getProcessNodeInfoFn();
        }
      }
    );
    /**
     * 监听workflowType变化
     */
    watch(
      () => props.workflowType,
      (val) => {
        data.flowList = [];
        getProcessNodeInfoFn();
      }
    );
    /**
     * 移除审核人
     */
    const deleFn = (node: any, index: any) => {
      if (props.workflowType === "common_flow" || props.workflowType === "office_supplies_use" || props.workflowType === "seal_apply"|| props.workflowType === 'common_contract') {
        data.flowList.splice(index, 1);
      } else {
        node.assignee = "";
        node.assigneeName = "";
      }
    };
    /**
     * 修改审核人
     */
    const clickAavatarFn = (node: any) => {
      selectNode = node;
      visible.value = !visible.value;
      selectAuditUser.value = node.assignee;
      getStaffTree();
    };

    /**
     * 验证数据
     */
    const validateFn = () => {
      const result = props.modelValue.every((_: any) => _.assignee);
      if (!result) {
        ElMessage.warning({
          message: "审批流程节点未勾选完",
          type: "warning",
        });
      }
      return result;
    };

    onMounted(() => {      
      if(props.workflowType === 'material_progress_payment' || props.workflowType === 'material_prepaid_payment'){
        data.currentApproval = 99;
        props.modelValue.forEach((item: any, index: any)=>{
          if(item.taskDefinitionKey === props.currentTask){
            data.currentApproval = index;
          }
        });
     }
    });
    onActivated(() => {    
      getProcessNodeInfoFn();
    });

    return {
      data,
      validateFn,
      createPathTable,
      selectAuditUser,
      visible,
      appendFn,
      deleFn,
      clickAavatarFn,
      workType,
    };
  },
});
